import { RadioCard } from '@pocketlaw/tetris';
import { Field, useFormikContext } from 'formik';
export function OptionField(props) {
    const { value, label, description } = props;
    const { isSubmitting } = useFormikContext();
    // eslint-disable-next-line lingui/text-restrictions
    const uiEventValue = `Convert document to free-text - '${value}' selection`;
    return (<Field value={value} title={label} as={RadioCard} subtitle={description} disabled={isSubmitting} data-ui-event={uiEventValue} type="radio" name="document"/>);
}
